import { render } from "./SupportMain.vue?vue&type=template&id=310b7253&scoped=true"
import script from "./SupportMain.vue?vue&type=script&lang=js"
export * from "./SupportMain.vue?vue&type=script&lang=js"

import "./SupportMain.vue?vue&type=style&index=0&id=310b7253&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310b7253"]])

export default __exports__